<template>
<div>
  <div class="main-content">
    <div class="content-block box">
      <div class="content">
        <div class="user-area">
          <button class="pure-button add-btn" @click="addEmpty">ユーザー追加</button>
          <table class="pure-table" ref="table">
            <thead class="table-header" ref="thead">
              <tr :style="{ width: theadTrWidth }">
                <td class="td-attri1 pure-form">属性1</td>
                <td class="td-attri2">属性2</td>
                <td class="td-name">氏名</td>
                <td class="td-mail">メールアドレス</td>
                <td class="td-auth">権限</td>
                <td class="td-delete">削除</td>
              </tr>
            </thead>
            <tbody :style="{ height: tbodyHeight + 'px' }">
              <tr ref="tbodyTr" v-for="user in users" :key="user.ID">
                <td class="td-attri1 pure-form">
                  <input class="input-attri1" type="text" v-model="user.Attribute1">
                  <button class="pure-button save-button" @click="saveAttribute(user.ID, user.Attribute1, 1)">保存</button>
                </td>
                <td class="td-attri2 pure-form">
                  <input class="input-attri2" type="text" v-model="user.Attribute2">
                  <button class="pure-button save-button" @click="saveAttribute(user.ID, user.Attribute2, 2)">保存</button>
                </td>
                <td class="td-name">{{ user.Name }}</td>
                <td class="td-mail">{{ user.Mail }}</td>
                <td class="td-auth">
                  <div 
                    v-if="user.ID != userID"
                    class="authority" 
                    :style="{color: authColor(user.Authority)}" 
                    @click="changeAuth(user.ID)"
                  >
                    {{ authName(user.Authority) }}
                  </div>
                  <div v-else>
                    {{ authName(user.Authority) }}
                  </div>
                </td>
                <td class="td-delete">
                  <button class="pure-button delete-btn" @click="deleteUser(user.ID)" v-if="user.ID != userID">削除</button>
                </td>
              </tr>
            </tbody>
          </table>
           <transition name="modal">
              <div class="modal-mask" v-if="showModal">
                <div class="modal-wrapper">
                  <div class="modal-container">
                    <form @submit="addUser">
                    <table>
                      <div class="user-info">ユーザー情報入力</div>
                      <tr class="modal-attribute1">
                        <td class="modal-label" name="attribute1">属性1</td>
                        <td><input type="attribute1" class="modal-details" v-model="user.attribute1"></td>
                      </tr>
                      <tr class="modal-attribute2">
                        <td class="modal-label" name="attribute2">属性2</td>
                        <td><input type="attribute2" class="modal-details" v-model="user.attribute2"></td>
                      </tr>                      
                      <tr class="model-name">
                        <td class="modal-label" name="name">氏名</td>
                        <td><input type="name" class="modal-details" v-model="user.name" required></td>
                      </tr>
                      <tr class="model-nameKana">
                        <td class="modal-label" name="nameKana">氏名（カナ）</td>
                        <td><input type="nameKana" class="modal-details" v-model="user.nameKana" required></td>
                      </tr>
                      <tr class="modal-mail">
                        <td class="modal-label" name="mail">メールアドレス</td>
                        <td><input type="mail" class="modal-details" v-model="user.mail" required></td>
                      </tr>
                      <tr class="modal-authority">
                        <td class="modal-label" name="authority">権限</td>
                        <td class="authority-down">
                          <select name=”authority-down” v-model="user.authority">
                            <option value="0">管理者</option>
                            <option value="1">一般</option>
                            <option value="2">確認者</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                    <button class="pure-button modal-regist-button">登録</button>
                    <div class="pure-button modal-cancel-button" @click="showModal = false">キャンセル</div>
                   </form>
                  </div>
                </div>
              </div>
            </transition>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      observer: null,
      tableHeight: 0,
      theadHeight: 0,
      tbodyTrWidth: 0,

      users: {},
      user: {
        name: "",
        nameKana: "",
        mail: "",
        authority: 0,
        attribute1: "",
        attribute2: ""
      }
    }
  },

  beforeMount() {
    let storedUsers = this.$store.state.store.users
    if (Object.keys(storedUsers).length != 0) {
      this.users = storedUsers
    }
    
    this.$emit("send", this.getUsers)
  },

  mounted() {
    this.setResizeObserver()
  },
  
  beforeDestroy() {
    this.removeResizeObserver()
  },

  watch: {
    users() {
      this.$nextTick(() => {
        this.getSizeForLayout()
      })
    }
  },

  computed: {
    userID() {
      return this.$store.state.store.user.userID
    },

    authColor() {
      return (auth) => {
        switch (auth) {
          case 0:
            return 'crimson'
          case 1:
            return 'steelblue'
          case 2:
            return 'mediumseagreen'
          default:
            break
        }
      }
    },

    authName() {
      return (auth) => {
        switch (auth) {
          case 0:
            return '管理者'
          case 1:
            return '一般'
          case 2:
            return '確認者'
          default:
            break
        }
      }
    },

    tbodyHeight() {
      return this.tableHeight - this.theadHeight
    },

    theadTrWidth() {
      return this.tbodyTrWidth == 0 ? 'auto' : this.tbodyTrWidth + 'px'
    }
  },

  methods: {
    getUsers() {
      this.$http.get("/user").then((res) => {
        let users = res.data.users
        this.users = users
        this.$store.dispatch("setUsers", users)
      })
    },

    saveAttribute(id, attribute, attributeNo) {
      var params = new URLSearchParams()
      params.append("id", id)
      params.append("attribute", attribute)
      params.append("attributeNo", attributeNo)
      
      if (confirm("属性を保存しますか？")) {
        this.$http.post("/save_attribute", params)
          .then(() => {
            alert("属性を保存しました。")
            this.getUsers()
          }).catch(() => {
            if (err.response.data.message) {
            alert(err.response.data.message)
          } else {
            alert("属性の保存に失敗しました。")
          }
        })
      }
    },

    changeAuth(id) {
      if (confirm("権限を変更しますか？")) {
        this.$http.get("/auth_change", {
          params: { id: id }
        }).then(() => {
          alert("権限を変更しました。")
          this.getUsers()
        }).catch((err) => {
          if (err.response.data.message) {
            alert(err.response.data.message)
          } else {
            alert("権限の変更に失敗しました。")
          }
        })
      }
    },

    deleteUser(id) {
      if (confirm("ユーザーを削除しますか？")) {
        this.$http.get("/delete_user", {
          params: { id: id }
        }).then(() => {
          alert("ユーザーを削除しました。")
          this.getUsers()
        }).catch((err) => {
          if (err.response.data.message) {
            alert(err.response.data.message)
          } else {
            alert("ユーザーの削除に失敗しました。")
          }
        })
      }
    },

    setResizeObserver() {
      this.observer = new ResizeObserver(function() {
        this.theadHeight = this.$refs.thead.clientHeight
        if (this.$refs.tbodyTr && 0 < this.$refs.tbodyTr.length) {
          this.tbodyTrWidth = this.$refs.tbodyTr[0].clientWidth
        }
      }.bind(this))

      this.observer.observe(this.$refs.thead)
    },

    removeResizeObserver() {
      this.observer.unobserve(this.$refs.thead)
    },

    getSizeForLayout() {
      this.tableHeight = this.$refs.table.clientHeight - 4
      this.theadHeight = this.$refs.thead.clientHeight
      if (this.$refs.tbodyTr && 0 < this.$refs.tbodyTr.length) {
        this.tbodyTrWidth = this.$refs.tbodyTr[0].clientWidth
      }
    },
    
    addEmpty() {
      this.showModal = true

      this.user.name = ""
      this.user.nameKana = ""
      this.user.mail = ""
      this.user.authority = 0
      this.user.attribute1 =""
      this.user.attribute2 = ""
    },

    addUser() {
      var params = new URLSearchParams()
      params.append("name", this.user.name)
      params.append("nameKana", this.user.nameKana)
      params.append("mail", this.user.mail)
      params.append("authority", this.user.authority)
      params.append("attribute1", this.user.attribute1)
      params.append("attribute2", this.user.attribute2)
      
      if (confirm("ユーザーを登録しますか？")) {
        this.$http.post("/add_user", params)
          .then(() => {
            location.reload()
          })
          .catch(() => {
            alert("ユーザーの追加に失敗しました。")
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-area {
  width: fit-content;
  max-width: 95%;
  height: calc(100% - 68px);
  margin: 10px auto;
}

.add-btn {
 float: right;
 margin: 0 1px 8px 0;
 padding: 10px 14px;
 background: linear-gradient(135deg, #fff5ee, #bce2e8);
}

table {
  table-layout: fixed;
}

.table-header {
  background: linear-gradient(180deg, #fffaf0, #dcdcdc);
}

.input-attri1, .input-attri2 {
  width: 60%;
}

.td-attri1, .td-attri2 {
  width: 20%;
  min-width: 70px;
  padding: 5px 0px;
}

.td-name {
  width: 12%;
  padding: 0px;
}

.td-mail {
  width: 20%;
  padding: 10px;
}

.td-auth {
  width: 7%;
  padding: 0px;
}

.td-delete {
  width: 5%;
  min-width: 64px;
}

.save-button {
  margin-left: 5px;
  background: linear-gradient(135deg, #fff5ee, #a2d7dd);
}

.authority {
  cursor: pointer;
  position: relative;
  display: inline-block;
  text-decoration: none;
}

.authority::after {
  position: absolute;
  bottom: 1px;
  left: 0;
  content: '';
  width: 100%;
  height: 3px;
  background: radial-gradient(#6495ed, transparent);
  opacity: 0;
  visibility: hidden;
  transition: .3s;
}

.authority:hover::after {
  bottom: -4px;
  opacity: 1;
  visibility: visible;
}

.delete-btn {
  background: linear-gradient(45deg, #ffffb7, #FF6666);
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-details {
  width: -webkit-fill-available;
}

.user-info {
  font-weight: bold;
  font-size: x-large;
  margin: 0 0 25px 10px;
}

.modal-attribute1, .modal-attribute2, .modal-name,
.model-nameKana, .modal-mail, .modal-authority {
  margin: 20px 0;
}

.modal-regist-button {
  margin: 15px 20px;
  background: linear-gradient(-45deg, #fff5ee, #bce2e8);
}

.modal-cancel-button {
  margin: 15px 20px;
  background: linear-gradient(125deg, #ffffb7, #FF6666);
}

.modal-enter, .modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-label {
  width: 40%;
}

// 権限のプルダウン
.authority-down {
  position: relative;
}

// <>の表示位置
.authority-down:after {
  content: '<>';
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 4px;
  top: 3px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

// プルダウン幅
.authority-down select {
  -webkit-appearance: none;
  width: -webkit-fill-available;
  height: 25px;
  border-radius: 2px;
  padding: 3px;
}

@media screen and (max-width: 420px) {
  .user-area {
    overflow-x: scroll;
  }

  table {
    table-layout: unset;
  }

  tr {
    table-layout: fixed;
  }

  .td-attri1, .td-attri2 {
    width: 100px;
  }

  .td-name {
    width: 100px;
  }

  .td-mail {
    width: 180px;
  }

  .td-auth {
    width: 55px;
  }

  .td-delete {
    width: 45px;
  }
}
</style>